import React from 'react';
import '../styles/contact.css';

function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-info">
        <h2 className='loc'>LOCATION</h2>
        <p>Phoenix Tower,</p>
<p>Waziran District, Zagros Street</p>
<p>Office No. 411, Erbil, Iraq</p>
        <h2 className='con'>Contact Us</h2>
        <p>info@ava-architects.krd</p>
        <p>+964 (0) 750 446 0414</p>
        <p>+964 (0) 750 467 3973</p>
        <p>+964 (0) 770 466 0414</p>
        <p>+964 (0) 770 140 5060</p>

        {/* Social Media inline with text */}
        <p className="social-links">
          Follow us:
          <a 
            href="https://www.facebook.com/AVAConsultancyOffice" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src="/icons/facebook.png" alt="Facebook" />
          </a>
          <a 
            href="https://www.instagram.com/avaarchitectss/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src="/icons/instagram.png" alt="Instagram" />
          </a>
        </p>
      </div>

<div className="contact-map">
  <iframe
    title="Office Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2947.1587467824625!2d43.9839075!3d36.19925349999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4007238b47842643%3A0x4213883ffcc65171!2sPhoenix%20Tower!5e1!3m2!1sen!2siq!4v1781128570780!5m2!1sen!2siq"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>
    </div>
  );
}

export default Contact;
